module.exports = __webpack_public_path__ + "static/media/overlay_green.f6ca8fcb.svg";